import { render, staticRenderFns } from "./ServicePack.vue?vue&type=template&id=1ba09846&"
import script from "./ServicePack.vue?vue&type=script&lang=js&"
export * from "./ServicePack.vue?vue&type=script&lang=js&"
import style0 from "./ServicePack.vue?vue&type=style&index=0&id=1ba09846&prod&lang=scss&default=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports